import MoreHoriz from '@mui/icons-material/MoreHoriz';
import { Tooltip } from '@mui/material';
import { styled } from '@mui/material/styles';
import { useSwimlaneRootProps } from '@/components/ui/swimlane/context';
import { HeaderCell } from '../HeaderCell';
import { SwimlaneHeaderMenu } from '../menu/SwimlaneHeaderMenu';
import type { IHeaderProps } from '../types';

export type ColumnHeaderProps = IHeaderProps & React.HTMLAttributes<HTMLDivElement>;

// Consider refactoring the SL and headers to properly pass the config instead of requiring the consumer to redefine this component
export function ColumnHeader({
  backgroundColor = 'transparent',
  labelColor = 'inherit',
  children = '',
  onOpenCard,
  hideHeader,
  openCardLabel = '',
  hideHeaderTooltip,
  reorderDisabledTooltip,
  isReOrderingDisabled = false,
  isViewCardOptionDisabled = false,
  ...containerProps
}: ColumnHeaderProps) {
  const { isPublicationMode, isHeaderMenuDisabled } = useSwimlaneRootProps();

  // Backwards compatibility: if isHeaderMenuDisabled is not passed, only use isPublicationMode
  const shouldHideMenu = isHeaderMenuDisabled !== undefined ? isHeaderMenuDisabled : false;

  return (
    <ColumnHeaderCell
      role="columnheader"
      $backgroundColor={backgroundColor}
      $labelColor={labelColor}
      {...containerProps}
    >
      <Tooltip title={children as string} placement="bottom">
        <ColumnHeaderText className="fs-exclude" data-dd-action-name="swimlane label - redacted">
          {children}
        </ColumnHeaderText>
      </Tooltip>
      {!isPublicationMode && !shouldHideMenu && (
        <SwimlaneHeaderMenu
          onOpenCard={onOpenCard}
          hideHeader={hideHeader}
          openCardLabel={openCardLabel}
          Icon={MoreHoriz}
          hideHeaderTooltip={hideHeaderTooltip}
          reorderDisabledTooltip={reorderDisabledTooltip}
          isReOrderingDisabled={isReOrderingDisabled}
          isViewCardOptionDisabled={isViewCardOptionDisabled}
          isHeaderMenuDisabled={isHeaderMenuDisabled}
          level={1}
        />
      )}
    </ColumnHeaderCell>
  );
}

const ColumnHeaderText = styled('span')({
  overflow: 'hidden',
  textOverflow: 'ellipsis',
  whiteSpace: 'nowrap',
  fontSize: '0.875rem',
  lineHeight: '20px',
  fontWeight: 600,
  letterSpacing: '0.5px',
  textTransform: 'uppercase',
  width: '100%',
  textAlign: 'center',
});

const ColumnHeaderCell = styled(HeaderCell)({
  height: '32px',
  justifyContent: 'space-between',
  padding: '0 12px',
  top: '0',
  width: '100%',
  display: 'flex',
});
